import { IPodData } from 'services/pod/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHaloPodDataByContactId } from 'services/pod';
import { convertSimplifiedToPodData } from 'store/pod/helpers';

interface IProps {
  psaId: number;
  contactId: number;
}

export const ThunkGetHaloPodByContactId = createAsyncThunk<IPodData, IProps>(
  'pod/getHaloPodDataByContactId',
  async ({ psaId, contactId }) =>
    getHaloPodDataByContactId(psaId, contactId)
      .then(r => r.data)
      .then(data => convertSimplifiedToPodData(data)),
);
